import { useState, useEffect, useCallback } from 'react';

import { ISearchableChecklistItem } from './SearchableChecklistItem';

declare type FilterType = {
    key: string;
    expectedValue: string;
};
export interface IFiltersInterface {
    [key: string]: FilterType[];
}

const useSearchableChecklist = (items: any[]) => {
    const [currentList, setCurrentList] = useState(items);
    const [filteredList, setFilteredList] = useState<Array<any> | null>(null);
    const [selectedCount, setSelectedCount] = useState(0);
    const [filters, setFilters] = useState({});
    const selectAll = () => {
        const FilteredList = filteredList?.map((item) => {
            return {
                ...item,
                selected: item.errors.length <= 0 && !(item.disabled && item.hasTooltip) ? true : item.selected,
                changed: !item.selected,
            };
        });
        const FilteredListItemsIDArray = filteredList?.map((item) => item.id);
        const list = currentList.map((item: ISearchableChecklistItem) => {
            if (FilteredListItemsIDArray !== undefined) {
                return {
                    ...item,
                    selected:
                        FilteredListItemsIDArray?.includes(item.id) &&
                        item.errors.length <= 0 &&
                        !(item.disabled && item.hasTooltip)
                            ? true
                            : item.selected,
                    changed: FilteredListItemsIDArray?.includes(item.id) ? !item.selected : item.changed,
                };
            } else {
                return {
                    ...item,
                    selected: item.errors.length <= 0 && !(item.disabled && item.hasTooltip) ? true : item.selected,
                    changed:
                        item.errors.length <= 0 && !(item.disabled && item.hasTooltip) ? !item.selected : item.changed,
                };
            }
        });
        setFilteredList(FilteredList ?? null);
        setCurrentList(list);
    };

    const selectNone = () => {
        const FilteredList = filteredList?.map((item) => {
            return { ...item, selected: false, changed: item.selected };
        });
        const FilteredListItemsIDArray = filteredList?.map((item) => item.id);
        const list = currentList.map((item: ISearchableChecklistItem) => {
            if (FilteredListItemsIDArray !== undefined) {
                return {
                    ...item,
                    selected: FilteredListItemsIDArray?.includes(item.id) ? false : item.selected,
                    changed: FilteredListItemsIDArray?.includes(item.id) ? item.selected : item.changed,
                };
            }
            return {
                ...item,
                selected: false,
                changed: item.selected,
            };
        });
        setFilteredList(FilteredList ?? null);
        setCurrentList(list);
    };

    const getSelected = useCallback(() => {
        return currentList.filter((item: ISearchableChecklistItem) => item?.selected);
    }, [currentList]);

    const getChanged = useCallback(() => {
        return currentList.filter((item: ISearchableChecklistItem) => item?.changed);
    }, [currentList]);

    const onSearchChange = (value: string, filtersTemp?: any) => {
        const FiltersObject = filtersTemp ?? filters;
        const isFilterApplied = Object.keys(FiltersObject).length > 0;

        if (value.length > 0) {
            const FilteredList = currentList.filter(
                (item: ISearchableChecklistItem) => item.keywords.toLowerCase().indexOf(value.toLowerCase()) > -1,
            );
            if (isFilterApplied) {
                const newList = applyFiltersToList(FiltersObject, FilteredList);
                if (newList) {
                    setFilteredList(newList);
                    return;
                }
            }
            setFilteredList(FilteredList);
        } else {
            if (isFilterApplied) {
                const newList = applyFiltersToList(FiltersObject, currentList);
                if (newList) {
                    setFilteredList(newList);
                }
                return;
            }
            setFilteredList(null);
        }
    };

    const onCheckboxChange = (checked: boolean, index: number) => {
        if (filteredList) {
            const list = [...filteredList];
            list[index].selected = checked;
            list[index].changed = true;
            setFilteredList(list);
            const currentListTemp = [...currentList];
            const currentItemIndex = currentListTemp.findIndex((item) => item.id === list[index].id);
            currentListTemp[currentItemIndex].selected = checked;
            currentListTemp[currentItemIndex].changed = true;
            setCurrentList(currentListTemp);
        } else {
            const list = [...currentList];
            list[index].selected = checked;
            list[index].changed = true;
            setCurrentList(list);
        }
    };

    const applyFiltersToList = (filters: IFiltersInterface, listToBeFiltered: any[]) => {
        if (filters) {
            const loopList = listToBeFiltered;
            let filterEmpty = true;
            const FilteredList = loopList.filter((item: ISearchableChecklistItem) => {
                let flag: boolean = false;
                let flagHasBeenSet = false;
                Object.values(filters).forEach((filterOptionArray: FilterType[]) => {
                    flag = false;
                    if (filterOptionArray.length > 0) {
                        filterEmpty = false;
                    }
                    if (!flag && !flagHasBeenSet) {
                        filterOptionArray.forEach((filterOption) => {
                            if (!flag) {
                                flag = item[filterOption.key] === filterOption.expectedValue;
                                flagHasBeenSet = !flag;
                            }
                        });
                    }
                });
                console.log(flag);

                return flag;
            });
            if (filterEmpty) {
                return false;
            } else {
                return FilteredList;
            }
        } else {
            return false;
        }
    };

    const applyFilters = (filters: IFiltersInterface, searchValue: string) => {
        setFilters(filters);
        const newList = applyFiltersToList(filters, searchValue.length && filteredList ? filteredList : currentList);
        if (newList === false || Object.keys(filters).length === 0) {
            onSearchChange(searchValue, filters);
        } else {
            setFilteredList(newList);
        }
    };

    useEffect(() => {
        setSelectedCount(getSelected().length);
        //eslint-disable-next-line
    }, [currentList]);
    return {
        currentList,
        setCurrentList,
        selectAll,
        selectNone,
        getSelected,
        getChanged,
        onSearchChange,
        selectedCount,
        setSelectedCount,
        onCheckboxChange,
        applyFilters,
        filteredList,
    };
};

export default useSearchableChecklist;
